if (!customElements.get('simp-content-page')) {
  customElements.define('simp-content-page', class extends HTMLElement {
    connectedCallback() {
      this._onPlay = event => {
        const button = event.target.closest('[data-film-play]');
        if (!button || !this.contains(button)) return;
        const host = button.closest('[data-film-host]');
        const id = button.dataset.videoId;
        const provider = button.dataset.provider;
        if (!host || !id || !/^[a-zA-Z0-9_-]+$/.test(id)) return;
        const iframe = document.createElement('iframe');
        iframe.src = provider === 'vimeo' ? `https://player.vimeo.com/video/${id}?autoplay=1&dnt=1` : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        iframe.title = button.dataset.title || button.getAttribute('aria-label');
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        host.replaceChildren(iframe);
        iframe.focus();
      };
      this.addEventListener('click', this._onPlay);
    }
    disconnectedCallback() { this.removeEventListener('click', this._onPlay); }
  });
}
